import React from 'react';
import CalculusOfConversation from '../components/CalculusOfConversation';

function CalculusOfConversationPage() {
  return <CalculusOfConversation />;
}

export default CalculusOfConversationPage;
